import { render, staticRenderFns } from "./ComplaintFinalizeModal.vue?vue&type=template&id=6fdeecf7&scoped=true"
import script from "./ComplaintFinalizeModal.vue?vue&type=script&lang=js"
export * from "./ComplaintFinalizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdeecf7",
  null
  
)

export default component.exports